import { TEAM_ACCESS_ROLES } from "../../utils/teamRoles";

/**
 * Accessible role picker — hidden radios + label cards (reliable clicks in dark mode).
 */
export default function TeamRolePicker({
  value,
  onChange,
  disabledRoleValues = [],
  name = "teamAccessRole",
  idPrefix = "team-role",
}) {
  return (
    <div className="row g-3">
      {TEAM_ACCESS_ROLES.map((role) => {
        const inputId = `${idPrefix}-${role.value}`;
        const isDisabled = disabledRoleValues.includes(role.value);
        const isActive = value === role.value;

        return (
          <div key={role.value} className="col-md-6">
            <input
              type="radio"
              className="btn-check"
              name={name}
              id={inputId}
              value={role.value}
              checked={isActive}
              disabled={isDisabled}
              onChange={() => onChange(role.value)}
              autoComplete="off"
            />
            <label
              htmlFor={inputId}
              className={`donezo-team-role-option w-100${isActive ? " is-active" : ""}${
                isDisabled ? " is-disabled" : ""
              }`}
            >
              <span className="donezo-team-role-option__icon" aria-hidden>
                <i className={`fa ${role.icon}`} />
              </span>
              <span>
                <div className="donezo-team-role-option__title">{role.title}</div>
                <p className="donezo-team-role-option__desc">{role.description}</p>
              </span>
            </label>
          </div>
        );
      })}
    </div>
  );
}
